import { useEffect, useReducer } from 'react'

type ExceptionsState = {
  allExceptions: unknown[]
  currentException: unknown
  isGalleryOpen: boolean
}

type UseExceptionsResult = {
  allExceptions: unknown[]
  currentException: unknown
  isExceptionGalleryViewOpen: boolean
  handleCardClick: (exception: unknown) => void
  handleGalleryClose: () => void
}

const useExceptions = (exceptions: unknown[] = []): UseExceptionsResult => {
  const [exceptionsState, setExceptionsState] = useReducer(
    (prevState: ExceptionsState, newState: Partial<ExceptionsState>) => ({ ...prevState, ...newState }),
    {
      allExceptions: exceptions,
      currentException: {},
      isGalleryOpen: false,
    }
  )

  const { allExceptions, isGalleryOpen, currentException } = exceptionsState

  const handleCardClick = (exception: unknown) => {
    setExceptionsState({ isGalleryOpen: true, currentException: exception })
  }

  const handleGalleryClose = () => {
    setExceptionsState({ isGalleryOpen: false, currentException: null })
  }

  useEffect(() => {
    setExceptionsState({ allExceptions: exceptions })
  }, [exceptions])

  return {
    allExceptions,
    currentException,
    isExceptionGalleryViewOpen: isGalleryOpen,
    handleCardClick,
    handleGalleryClose,
  }
}

export default useExceptions
